var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "connection_svg__connection_icon",
    d: "M.563 6H18v2.626c0 1.385 1.712 2.019 2.621.996l3-3.375a1.5 1.5 0 000-1.993l-3-3.375C19.713-.143 18 .49 18 1.876V4.5H.562A.563.563 0 000 5.063v.375c0 .31.252.563.563.563zM19.5 1.877l3 3.375-3 3.375v-6.75zM23.438 12H6V9.376c0-1.386-1.712-2.02-2.621-.997l-3 3.375a1.5 1.5 0 000 1.993l3 3.375c.908 1.022 2.621.39 2.621-.996V13.5h17.438c.31 0 .562-.252.562-.563v-.375a.563.563 0 00-.563-.562zM4.5 16.126l-3-3.375 3-3.375v6.75z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/connection.942d746ec6b6f63c2c96c8e2b00323ad.svg";
export { SvgConnection as ReactComponent };